import React from 'react'
import { observer } from 'mobx-react'
import Price from 'app/React/ProductForm/Price'
import BasketButton from 'app/React/ProductForm/BasketButton'

function Footer () {
  return (
    <>
      <div className={'single_variation_wrap'}>
        <Price/>
        <div className="woocommerce-variation-add-to-cart variations_button woocommerce-variation-add-to-cart-disabled">
          <BasketButton/>
        </div>
      </div>

      <div id={'mtt-price-field'}></div>
    </>
  )
}

export default observer(Footer)